import React from 'react';
import { TabsProps, TabsContextProps, TabProps, PanelProps, TabsCompositionProps } from './types';
import {TabButton} from '@magoosh/lib/button';

export const TabsContext = React.createContext<TabsContextProps | undefined>(undefined);

export const useTabs = (): TabsContextProps => {
  const context = React.useContext(TabsContext);
  if (!context) {
    throw new Error('This component must be used within a <Tabs> component.');
  }
  return context;
};

export const Tab: React.FC<TabProps> = (props) => {
  const { activeTab, setActiveTab } = useTabs();
  return (
    <TabButton
      disabled={activeTab === props.tab}
      onClick={() => setActiveTab(props.tab)}>{props.children}
    </TabButton>
  )
};

export const Panel: React.FC<PanelProps> = (props) => {
  const { activeTab } = useTabs();
  return activeTab === props.tab ? <div className="u-margin-T-m">{props.children}</div> : null;
};

export const Tabs: React.FC<TabsProps> & TabsCompositionProps = (props) => {
  const [activeTab, setActiveTab] = React.useState(props.defaultTab);
  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <div>{props.children}</div>
    </TabsContext.Provider>
  );
};

Tabs.Tab = Tab;
Tabs.Panel = Panel;

export default Tabs;
